import {css} from 'lit';
export const styles = css`:host {
  --section-gap: 32px;
  --section-background: transparent;

  display: block;
  margin-left: calc(var(--page-padding-x) * -1);
  margin-right: calc(var(--page-padding-x) * -1);
  padding-top: var(--section-padding-block);
  padding-bottom: var(--section-padding-block);
  padding-left: var(--page-padding-x);
  padding-right: var(--page-padding-x);
  padding-left: var(--section-padding-inline, var(--page-padding-x));
  padding-right: var(--section-padding-inline, var(--page-padding-x));
  background-color: var(--section-background);
}

:host([theme]) {
  --section-padding-block: var(--page-padding-x);
}

@media (min-width: 768px) {

:host([theme]) {
    margin-left: 0;
    margin-right: 0
}
  }

:host([theme='white']) {
  --section-background: var(--contrast-light);
}

:host([theme='gray']) {
  --section-background: var(--body-bg);
}

:host([theme='primary']) {
  --section-background: var(--primary);
}

:host([gap='0']) {
  --section-gap: 0;
}

:host([gap='1']) {
  --section-gap: 4px;
}

:host([gap='2']) {
  --section-gap: 8px;
}

:host([gap='3']) {
  --section-gap: 16px;
}

:host([gap='4']) {
  --section-gap: 32px;
}

:host([block='0']) {
  --section-padding-block: 0;
}

:host([block='1']) {
  --section-padding-block: 4px;
}

:host([block='2']) {
  --section-padding-block: 8px;
}

:host([block='3']) {
  --section-padding-block: 16px;
}

:host([block='4']) {
  --section-padding-block: 32px;
}

:host([inline='0']) {
  --section-padding-inline: 0;
}

:host([inline='1']) {
  --section-padding-inline: 4px;
}

:host([inline='2']) {
  --section-padding-inline: 8px;
}

:host([inline='3']) {
  --section-padding-inline: 16px;
}

:host([inline='4']) {
  --section-padding-inline: 32px;
}

:host(:empty) {
  display: none;
}

@media (min-width: 576px) {
  :host([gapXs='0']) {
    --section-gap: 0;
  }

  :host([gapXs='1']) {
    --section-gap: 4px;
  }

  :host([gapXs='2']) {
    --section-gap: 8px;
  }

  :host([gapXs='3']) {
    --section-gap: 16px;
  }

  :host([gapXs='4']) {
    --section-gap: 32px;
  }

  :host([blockXs='0']) {
    --section-padding-block: 0;
  }

  :host([blockXs='1']) {
    --section-padding-block: 4px;
  }

  :host([blockXs='2']) {
    --section-padding-block: 8px;
  }

  :host([blockXs='3']) {
    --section-padding-block: 16px;
  }

  :host([blockXs='4']) {
    --section-padding-block: 32px;
  }

  :host([inlineXs='0']) {
    --section-padding-inline: 0;
  }

  :host([inlineXs='1']) {
    --section-padding-inline: 4px;
  }

  :host([inlineXs='2']) {
    --section-padding-inline: 8px;
  }

  :host([inlineXs='3']) {
    --section-padding-inline: 16px;
  }

  :host([inlineXs='4']) {
    --section-padding-inline: 32px;
  }
}

@media (min-width: 768px) {
  :host([gapSm='0']) {
    --section-gap: 0;
  }

  :host([gapSm='1']) {
    --section-gap: 4px;
  }

  :host([gapSm='2']) {
    --section-gap: 8px;
  }

  :host([gapSm='3']) {
    --section-gap: 16px;
  }

  :host([gapSm='4']) {
    --section-gap: 32px;
  }

  :host([blockSm='0']) {
    --section-padding-block: 0;
  }

  :host([blockSm='1']) {
    --section-padding-block: 4px;
  }

  :host([blockSm='2']) {
    --section-padding-block: 8px;
  }

  :host([blockSm='3']) {
    --section-padding-block: 16px;
  }

  :host([blockSm='4']) {
    --section-padding-block: 32px;
  }

  :host([inlineSm='0']) {
    --section-padding-inline: 0;
  }

  :host([inlineSm='1']) {
    --section-padding-inline: 4px;
  }

  :host([inlineSm='2']) {
    --section-padding-inline: 8px;
  }

  :host([inlineSm='3']) {
    --section-padding-inline: 16px;
  }

  :host([inlineSm='4']) {
    --section-padding-inline: 32px;
  }
}

@media (min-width: 992px) {
  :host([gapMd='0']) {
    --section-gap: 0;
  }

  :host([gapMd='1']) {
    --section-gap: 4px;
  }

  :host([gapMd='2']) {
    --section-gap: 8px;
  }

  :host([gapMd='3']) {
    --section-gap: 16px;
  }

  :host([gapMd='4']) {
    --section-gap: 32px;
  }

  :host([blockMd='0']) {
    --section-padding-block: 0;
  }

  :host([blockMd='1']) {
    --section-padding-block: 4px;
  }

  :host([blockMd='2']) {
    --section-padding-block: 8px;
  }

  :host([blockMd='3']) {
    --section-padding-block: 16px;
  }

  :host([blockMd='4']) {
    --section-padding-block: 32px;
  }

  :host([inlineMd='0']) {
    --section-padding-inline: 0;
  }

  :host([inlineMd='1']) {
    --section-padding-inline: 4px;
  }

  :host([inlineMd='2']) {
    --section-padding-inline: 8px;
  }

  :host([inlineMd='3']) {
    --section-padding-inline: 16px;
  }

  :host([inlineMd='4']) {
    --section-padding-inline: 32px;
  }
}

@media (min-width: 1200px) {
  :host([gapLg='0']) {
    --section-gap: 0;
  }

  :host([gapLg='1']) {
    --section-gap: 4px;
  }

  :host([gapLg='2']) {
    --section-gap: 8px;
  }

  :host([gapLg='3']) {
    --section-gap: 16px;
  }

  :host([gapLg='4']) {
    --section-gap: 32px;
  }

  :host([blockLg='0']) {
    --section-padding-block: 0;
  }

  :host([blockLg='1']) {
    --section-padding-block: 4px;
  }

  :host([blockLg='2']) {
    --section-padding-block: 8px;
  }

  :host([blockLg='3']) {
    --section-padding-block: 16px;
  }

  :host([blockLg='4']) {
    --section-padding-block: 32px;
  }

  :host([inlineLg='0']) {
    --section-padding-inline: 0;
  }

  :host([inlineLg='1']) {
    --section-padding-inline: 4px;
  }

  :host([inlineLg='2']) {
    --section-padding-inline: 8px;
  }

  :host([inlineLg='3']) {
    --section-padding-inline: 16px;
  }

  :host([inlineLg='4']) {
    --section-padding-inline: 32px;
  }
}
`;
export default styles;
